import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';
import { H3, Body3 } from './Common.styles';


export const LeftContainer = styled.div`
    flex: 0 0 35%;
    padding-right:30px;
`;

export const Title = styled.h1`
    font-size: 24px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
`;

export const Subtitle = styled(Body3)`
    color: #555;
    margin-bottom: 20px;
    line-height: 140%;
`;

export const RightContainer = styled.div`
    flex: 0 0 65%;
    display: flex;
    flex-direction: column;
    gap: 20px;
    overflow-y: auto;
    max-height: calc(75vh - 20px);
    padding-right: 30px;
`;

export const SectionTitle = styled(H3)`
    border: 1px solid #DDE1E6;
    border-radius: 8px;
    padding: 10px 14px;
    display: flex;
    align-items: center;
`;

export const ProfilePhotoContainer = styled.div`
    padding: 20px;    
    justify-content: space-between;
    align-items: flex-start;  
    gap: 20px;
    border: 1px solid #DDE1E6;
    border-radius: 8px;
`;

export const ImagePreview = styled.img`
    width: 100px;
    height: 100px;
    border-radius: 50%; 
    background-color: #f0f0f0;
    object-fit: cover; 
    display: block;
    margin-right: 30px;
`;

export const ProfileImgWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    width: 100%;
`;

export const ImageWrapper = styled.div`
    flex: 0 0 60%;
    display: flex;
    align-items: center;
`;

export const BtnWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const ImageRequirements = styled.div`
    flex: 0 0 40%;
    border-left: 1px solid #DDE1E6;
    padding-left: 30px;

    h3 {
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 5px;
    }
    ul {
        margin: 10px;
        padding-left: 20px;
        list-style: disc;
        font-size: 14px;
        color: #666;
    }
`;

export const RemoveBtn = styled.button`
    background-color: #fff;
    border: 1px solid #fff;
    color: #61cbc9;
    font-size: 14px;
    margin-top: 10px;
`;

export const UserDetailsContainer = styled.form`
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 20px;
`;

export const InputFieldRow = styled.div`
    display: flex;
    gap: 10px;
`;

export const SuccessMessage = styled.div`
    background-color: rgba(97, 203, 201, 0.6);
    padding: 16px;
    font-size: 14px;
    color: #000;
    text-align: center;
    margin-top: 2px;
    border-radius: 8px;
    border-left: 3px solid rgba(97, 203, 201, 1);

    span {
        font-weight: bold;
    }
`;

export const InputLabel = styled.label`
    font-size: 16px;
    color: #61cbc9;
`;

export const InputGroup = styled.div`
    margin: 0;
`;

export const Star = styled.span`
    color: red;
    padding-left: 2px;
`;

export const SaveButton = styled.button`
    background-color: #61cbc9;
    color: #ffffff;
    padding: 12px 24px;
    font-size: 16px;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    width: 200px;
    transition: background-color 0.3s;

    &:hover {
        background-color: rgba(97, 203, 201, 0.9);
        color: #fff;
    }

    &:active {
        background-color: #003f7f;
        color: #ffffff;
    }

    &:disabled {
        background-color: #ccc;
        cursor: not-allowed;
    }
`;

export const ListingCard = styled.div`
    position: relative;
    border: 1px solid #61cbc9;
    border-radius: 8px;
    padding: 12px;
    width: calc(50% - 8px);
    box-sizing: border-box;
`;

export const ListingCardLink = styled.a`
    text-decoration: ${(props) => (props.$hovered ? 'underline' : 'none')};
    color: #000;
    font-weight: bold;
    font-size: 16px;
`;

export const ListingCardSub = styled.div`
    font-size: 13px;
    margin-top: 6px;
    color: #666;
`;

export const BackButton = styled.button`
    position: fixed;
    bottom: 32px;
    right: 32px;
    z-index: 100;
    padding: 8px 16px;
    background-color: #61cbc9;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    width: auto;
    min-width: 150px;
    height: 40px;
    transition: background-color 0.3s;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);  /* 浮動感 */

    &:hover {
        background-color: rgba(97, 203, 201, 0.9);
    }

    &:active {
        background-color: #003f7f;
    }
`;

// ============= New Two Column Layout =============

export const TwoColumnLayout = styled.div`
    display: flex;
    gap: 30px;
    width: 100%;
    overflow-y: auto;
    max-height: calc(75vh - 60px);
`;

export const LeftColumn = styled.div`
    flex: 0 0 35%;
    display: flex;
    flex-direction: column;
`;

export const RightColumn = styled.div`
    flex: 0 0 65%;
    display: flex;
    flex-direction: column;
    padding-right: 10px;
    
    &::-webkit-scrollbar {
        width: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #61cbc9;
        border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: rgba(97, 203, 201, 0.8);
    }
`;

// ============= Sync Button =============

export const SyncButton = styled.button`
    background-color: ${props => props.$syncing ? '#a8e6e4' : '#61cbc9'};
    border: none;
    padding: 4px;
    border-radius: 6px;
    margin-left: 12px;
    cursor: ${props => props.$syncing ? 'not-allowed' : 'pointer'};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
    opacity: ${props => props.$syncing ? 0.7 : 1};
`;

export const SyncIconImg = styled.img`
    width:14px;
    height: 14px;
    animation: ${props => props.$syncing ? 'spin 1s linear infinite' : 'none'};
`;

// ============= Listing Grid =============

export const ListingGrid = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 12px;
    margin-bottom: 24px;
`;

export const ListingCardDeleteBtn = styled.button`
    position: absolute;
    top: 6px;
    right: 6px;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 14px;
    color: #aaa;
    line-height: 1;
    padding: 0 2px;
    transition: color 0.15s;

    &:hover {
        color: #ef4444;
    }
`;

export const NoListingText = styled.div`
    font-size: 14px;
    color: #888;
    margin-bottom: 24px;
    margin-top: 12px;
`;

// ============= Password Updated At =============

export const PasswordUpdatedAt = styled.div`
    margin-top: 8px;
    color: #888;
    font-size: 12px;
    font-weight: 400;
`;

// ============= Role Item =============

export const RoleList = styled.div`
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const RoleLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px;
    border: 1px solid #DDE1E6;
    border-radius: 6px;
    cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
    background-color: ${props => props.$selected ? '#f0fffe' : '#fff'};
    opacity: ${props => props.$disabled ? 0.6 : 1};
`;

export const RoleCheckbox = styled.input.attrs({ type: 'checkbox' })`
    cursor: inherit;
    accent-color: #61cbc9;
    width: 18px;
    height: 18px;
`;

export const RoleName = styled.span`
    font-weight: ${props => props.$selected ? '600' : '400'};
    color: ${props => props.$selected ? '#333' : '#666'};
`;

export const CurrentRolesBox = styled.div`
    margin-top: 12px;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 6px;
    font-size: 14px;
    color: #666;
`;

// ============= Permission Panel =============

export const PermissionSection = styled.div`
    margin-top: 0px;
    padding: 0px 10px;
`;

export const PermissionPanel = styled.div`
    margin-top: 20px;
    opacity: ${props => props.$locked ? 0.4 : 1};
    pointer-events: ${props => props.$locked ? 'none' : 'auto'};
`;

export const PermissionBadge = styled.span`
    margin-left: 8px;
    font-size: 11px;
    color: #61cbc9;
    font-weight: normal;
`;

export const PermissionCheckbox = styled.input.attrs({ type: 'checkbox' })`
    margin-top: 4px;
    cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
    accent-color: #61cbc9;
    opacity: ${props => props.$disabled ? 0.5 : 1};
`;

export const RoleSelect = styled.select`
    width: 100%;
    padding: 12px;
    border: 1px solid #DDE1E6;
    border-radius: 8px;
    font-size: 14px;
    color: #333;
    background-color: #fff;
    cursor: pointer;
    transition: border-color 0.2s;

    &:focus {
        outline: none;
        border-color: #61cbc9;
    }

    &:hover {
        border-color: #61cbc9;
    }
`;

export const PermissionCategory = styled.div`
    border: 1px solid #DDE1E6;
    border-radius: 8px;
    margin-bottom: 12px;
    overflow: hidden;
    background-color: #fff;
    transition: all 0.2s;

    &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
`;

export const CategoryHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    background-color: ${props => props.$expanded ? '#f8f9fa' : '#fff'};
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: #f8f9fa;
    }
`;

export const CategoryHeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const CategoryTitle = styled.span`
    font-size: 15px;
    font-weight: 600;
    color: #333;
`;

export const CategoryCountBadge = styled.span`
    font-size: 12px;
    color: #888;
`;

export const ChevronIcon = styled.span`
    color: #61cbc9;
    display: flex;
    align-items: center;
    transition: transform 0.2s ease;
    transform: ${props => props.$expanded ? 'rotate(90deg)' : 'rotate(0deg)'};
`;

export const PermissionList = styled.div`
    padding: 8px;
    background-color: #fafbfc;
    border-top: 1px solid #DDE1E6;
`;

export const PermissionItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 12px;
    background-color: #fff;
    border-radius: 6px;
    margin-bottom: 8px;
    transition: all 0.2s;

    &:last-child {
        margin-bottom: 0;
    }

    &:hover {
        background-color: #f8f9fa;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    }
`;

export const PermissionItemInner = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    flex: 1;
`;

export const PermissionItemContent = styled.div`
    flex: 1;
`;

export const PermissionLabel = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: ${props => props.$enabled ? '#333' : '#999'};
    margin-bottom: 4px;
`;

export const PermissionDescription = styled.div`
    font-size: 12px;
    color: #666;
    line-height: 1.4;
`;

// ============= Status Text =============

export const ErrorText = styled.div`
    margin-top: 8px;
    font-size: 12px;
    color: #ef4444;
    margin-bottom: 4px;
`;

export const WarningText = styled.div`
    font-size: 12px;
    color: #f59e0b;
`;

export const SuccessText = styled.div`
    margin-top: 8px;
    font-size: 12px;
    color: #61cbc9;
`;

export const UpdatingText = styled.span`
    color: #f59e0b;
    margin-left: 8px;
`;

// ============= Error / Notification Popup =============

export const ErrorPopup = styled.div`
    position: fixed;
    top: 70px;
    right: -600px;
    transform: translateY(0%);
    background-color: rgba(97, 203, 201, 0.4);
    color: #333;
    padding: 12px 20px;
    border-radius: 8px;
    width: 80%;
    max-width: 400px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    transition: right 0.5s ease-in-out;
    ${({ show }) => show && `right: 10px;`}
`;

export const CloseButton = styled.button`
    background-color: transparent;
    color: #333;
    border: none;
    font-size: 24px;
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    font-weight: bold;

    &:hover {
        color: #61cbc9;
    }
`;

// ============= Delete Listing Popup =============

export const PopupOverlay = styled.div`
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

export const PopupBox = styled.div`
    background: #fff;
    border-radius: 12px;
    padding: 28px 32px;
    width: 360px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
    text-align: center;
`;

export const PopupTitle = styled.div`
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #1a1a1a;
`;

export const PopupMessage = styled.div`
    font-size: 14px;
    color: #555;
    margin-bottom: 24px;
`;

export const PopupActions = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;
`;

export const PopupCancelBtn = styled.button`
    padding: 8px 20px;
    border-radius: 8px;
    border: 1px solid #ddd;
    background: #f5f5f5;
    cursor: pointer;
    font-size: 14px;
    color: #555;
`;

export const PopupConfirmBtn = styled.button`
    padding: 8px 20px;
    border-radius: 8px;
    border: none;
    background: #ef4444;
    cursor: pointer;
    font-size: 14px;
    color: #fff;
    font-weight: 600;
`;

// ============= Global Styles =============

export const GlobalStyle = createGlobalStyle`
    @keyframes spin {
        from { transform: rotate(0deg); }
        to   { transform: rotate(-360deg); }
    }
`;